import React from 'react';

import { useVideoInfo } from 'hooks/videoInfo/useVideoInfo';

import './VideoTitle.less';

interface VideoTitleProps {
  videoId: string;
}
const VideoTitle: React.FC<VideoTitleProps> = ({
  videoId,
}: VideoTitleProps) => {
  const [_, { title }] = useVideoInfo(videoId);

  return <p className="videoTitle">{title ?? videoId}</p>;
};

export default VideoTitle;
